import { HttpClient } from '@hotmart-org-ca/hot-club-http/client/http-client'

import { APP_NAME_VERSION, APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from './constants'

const headers = { 'X-APP-NAME': APP_NAME_VERSION }

HttpClient.createQueryClient() // MF running in standalone mode
HttpClient.createInstance(
  APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_CONTENT_GATEWAY,
  process.env.CONTENT_URL as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_SPARKLE,
  process.env.BASE_URL as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_SCRAPER,
  process.env.API_SCRAPER as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_VULCANO,
  process.env.VULCANO_URL as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_ONBOARDING,
  process.env.API_ONBOARDING as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_HOTMART_AI,
  process.env.API_HOTMART_IA_BASE_URL as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_COMMUNITY_GATEWAY,
  process.env.COMMUNITY_GATEWAY_URL as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_CONTENT_SEARCH,
  process.env.CONTENT_SEARCH_URL as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_MY_ACCOUNT,
  process.env.MY_ACCOUNT_URL as string,
  {
    headers
  }
)
